import { defineComponent as _defineComponent } from 'vue'
import { createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import { ref, onBeforeMount, watch, computed } from 'vue';
import { Dark, useQuasar } from 'quasar';

// Personal components
import DialogUserAccount from '@components/dialog/user/DialogUserAccount.vue';
import DialogStorageManager from '@components/dialog/program/DialogStorageManager.vue';

// ViewModel
import { useStorageVM } from '@viewmodel/components/qStorage.vm';

// Personal libs
import { LocalStorageEnum } from '@shared/enum/localstorage.enum';
import { IUser } from '@shared/interface/model.interface';
import { tailleFichier } from '@shared/lib/tools.lib';
import { sessionManager } from '@shared/service/sessionManager/session-manager.class';

/**
 * Globals
 */

export default /*@__PURE__*/_defineComponent({
  __name: 'QLayoutHeaderMenu',
  setup(__props) {

// Vendor
const $q = useQuasar()

/**
 * Viewmodel
 */
const { videoList, videoTotalSize } = useStorageVM();

/**
 * Reactive data
 */
const darkmode = ref(false);
const showDialogUserAccount = ref(false);
const showDialogStorageManager = ref(false);

/**
 * Computed properties
 */
const connectedUser = computed<IUser | undefined>(
  () => sessionManager.currentUser.value,
);

/**
 * Watch
 */
watch(
  () => darkmode.value,
  (newVal: boolean) => {
    if (newVal != null) {
      Dark.set(newVal);
      localStorage.setItem(LocalStorageEnum.DARKMODE, JSON.stringify(newVal));
    }
  },
);

/**
 * Hooks
 */
onBeforeMount(() => {
  const localDarkmode = localStorage.getItem(LocalStorageEnum.DARKMODE);
  darkmode.value = localDarkmode == 'true';

  Dark.set(darkmode.value);
});

return (_ctx: any,_cache: any) => {
  const _component_q_item_label = _resolveComponent("q-item-label")!
  const _component_q_item_section = _resolveComponent("q-item-section")!
  const _component_q_toggle = _resolveComponent("q-toggle")!
  const _component_q_item = _resolveComponent("q-item")!
  const _component_q_separator = _resolveComponent("q-separator")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_list = _resolveComponent("q-list")!
  const _component_q_menu = _resolveComponent("q-menu")!
  const _directive_ripple = _resolveDirective("ripple")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_q_menu, {
      "max-width": "250px",
      "auto-close": ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_q_list, {
          bordered: "",
          padding: "",
          role: "list"
        }, {
          default: _withCtx(() => [
            _createCommentVNode(" DARKMODE "),
            _withDirectives((_openBlock(), _createBlock(_component_q_item, {
              tag: "label",
              clickable: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_q_item_section, {
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (darkmode.value = !darkmode.value))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_q_item_label, null, {
                      default: _withCtx(() => _cache[6] || (_cache[6] = [
                        _createTextVNode("Mode sombre")
                      ])),
                      _: 1 /* STABLE */
                    }),
                    _createVNode(_component_q_item_label, { caption: "" }, {
                      default: _withCtx(() => _cache[7] || (_cache[7] = [
                        _createTextVNode("Permet d'améliorer la lisibilité dans une ambiance sombre")
                      ])),
                      _: 1 /* STABLE */
                    })
                  ]),
                  _: 1 /* STABLE */
                }),
                _createVNode(_component_q_item_section, { side: "" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_q_toggle, {
                      color: "blue",
                      "icon-color": "black",
                      "checked-icon": "check",
                      "unchecked-icon": "close",
                      modelValue: darkmode.value,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((darkmode).value = $event)),
                      val: "darkmode",
                      class: "set-outline",
                      size: "lg",
                      "keep-color": ""
                    }, null, 8 /* PROPS */, ["modelValue"])
                  ]),
                  _: 1 /* STABLE */
                })
              ]),
              _: 1 /* STABLE */
            })), [
              [_directive_ripple]
            ]),
            (connectedUser.value != null)
              ? (_openBlock(), _createBlock(_component_q_separator, {
                  key: 0,
                  spaced: ""
                }))
              : _createCommentVNode("v-if", true),
            _createCommentVNode(" CACHE MANAGEMENT "),
            (connectedUser.value != null)
              ? (_openBlock(), _createBlock(_component_q_item, { key: 1 }, {
                  default: _withCtx(() => [
                    (_unref(videoTotalSize) > 0)
                      ? (_openBlock(), _createBlock(_component_q_item_section, { key: 0 }, {
                          default: _withCtx(() => [
                            _createVNode(_component_q_item_label, null, {
                              default: _withCtx(() => _cache[8] || (_cache[8] = [
                                _createTextVNode("Mémoire cache utilisée par les vidéos :")
                              ])),
                              _: 1 /* STABLE */
                            }),
                            _createVNode(_component_q_item_label, {
                              caption: "",
                              class: _normalizeClass(_unref($q).dark.isActive ? 'text-white' : 'text-black')
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_unref(tailleFichier)(_unref(videoTotalSize))) + " (" + _toDisplayString(_unref(videoList).length) + " vidéo" + _toDisplayString(_unref(videoList).length > 1 ? 's' : '') + ")", 1 /* TEXT */)
                              ]),
                              _: 1 /* STABLE */
                            }, 8 /* PROPS */, ["class"]),
                            _createVNode(_component_q_item_label, { class: "q-pt-sm" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_q_btn, {
                                  bordered: "",
                                  style: {"width":"100%"},
                                  label: "Gestion du cache",
                                  class: "set-outline",
                                  onClick: _cache[2] || (_cache[2] = ($event: any) => (showDialogStorageManager.value = true))
                                })
                              ]),
                              _: 1 /* STABLE */
                            })
                          ]),
                          _: 1 /* STABLE */
                        }))
                      : (_openBlock(), _createBlock(_component_q_item_section, { key: 1 }, {
                          default: _withCtx(() => [
                            _createVNode(_component_q_item_label, null, {
                              default: _withCtx(() => _cache[9] || (_cache[9] = [
                                _createTextVNode("Aucune vidéo en cache")
                              ])),
                              _: 1 /* STABLE */
                            })
                          ]),
                          _: 1 /* STABLE */
                        }))
                  ]),
                  _: 1 /* STABLE */
                }))
              : _createCommentVNode("v-if", true),
            (connectedUser.value != null)
              ? (_openBlock(), _createBlock(_component_q_separator, {
                  key: 2,
                  spaced: ""
                }))
              : _createCommentVNode("v-if", true),
            (connectedUser.value != null)
              ? (_openBlock(), _createBlock(_component_q_item, { key: 3 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_q_item_section, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_q_btn, {
                          bordered: "",
                          label: "Mon compte",
                          class: "set-outline",
                          onClick: _cache[3] || (_cache[3] = ($event: any) => (showDialogUserAccount.value = true))
                        })
                      ]),
                      _: 1 /* STABLE */
                    })
                  ]),
                  _: 1 /* STABLE */
                }))
              : _createCommentVNode("v-if", true)
          ]),
          _: 1 /* STABLE */
        })
      ]),
      _: 1 /* STABLE */
    }),
    _createVNode(DialogUserAccount, {
      show: showDialogUserAccount.value,
      onClose: _cache[4] || (_cache[4] = ($event: any) => (showDialogUserAccount.value = false))
    }, null, 8 /* PROPS */, ["show"]),
    _createVNode(DialogStorageManager, {
      show: showDialogStorageManager.value,
      onClose: _cache[5] || (_cache[5] = ($event: any) => (showDialogStorageManager.value = false))
    }, null, 8 /* PROPS */, ["show"])
  ], 64 /* STABLE_FRAGMENT */))
}
}

})